// extracted by mini-css-extract-plugin
export default {"formBox":"Support_formBox__iJuoo","textArea":"Support_textArea__b8KuQ","submitBtnBox":"Support_submitBtnBox__FLWKK"};